import { Input } from "antd";
import { FontAwesomeIcon, Icon } from "assets/icons";
import CreateButton from "components/CreateButton";

function LoyaltyListToolbar({ filters = null, searchValue, onSearchChange, searchPlaceholder, createLabel, onCreate }) {
  return (
    <div className="filter-campaign-container-1">
      <div className="search-input">
        {filters}
        <Input
          className="custom-input input-seller"
          prefix={<FontAwesomeIcon icon={Icon.faSearch} />}
          placeholder={searchPlaceholder}
          value={searchValue}
          onChange={onSearchChange}
          allowClear
        />
      </div>
      <CreateButton title={createLabel} className="btn-create" onClick={onCreate} />
    </div>
  );
}

export default LoyaltyListToolbar;
